import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../axios";
import formatCurrency from "../../utils/formatCurrency";
import { STORAGE_URL } from "../../constants";
import { ReactSortable } from "react-sortablejs";
import ErrorModal from "../../admin/components/ErrorModal";

export default function CheckoutPage() {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    const [file, setFile] = useState(null);
    const [success, setSuccess] = useState("");
    const [accounts, setAccounts] = useState([]);
    const [error, setError] = useState("");

    const [photos, setPhotos] = useState([]);
    const [uploadError, setUploadError] = useState("");
    const [uploading, setUploading] = useState(false);
    const [submitMessage, setSubmitMessage] = useState("");

    // const [provinces, setProvinces] = useState([]);
    // const [cities, setCities] = useState([]);
    // const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [courier, setCourier] = useState("jne");
    const [shippingCost, setShippingCost] = useState(null);
    const [checkingOngkir, setCheckingOngkir] = useState(false);


    useEffect(() => {
        fetchOrder();
        fetchBankAccounts();
    }, [id]);

    // useEffect(() => {
    //     const cached = localStorage.getItem("provinces");

    //     if (cached) {
    //         setProvinces(JSON.parse(cached));
    //     } else {
    //         axios.get("/rajaongkir/provinces").then((res) => {
    //             setProvinces(res.data);
    //             localStorage.setItem("provinces", JSON.stringify(res.data));
    //         });
    //     }
    // }, []);

    // useEffect(() => {
    //     if (selectedProvince) {
    //         axios
    //             .get(`/rajaongkir/cities/${selectedProvince}`)
    //             .then((res) => setCities(res.data));
    //     } else {
    //         setCities([]);
    //     }
    // }, [selectedProvince]);

    // const checkShippingCost = async () => {
    //     if (!selectedCity || !courier || !order) return;

    //     try {
    //         setCheckingOngkir(true);
    //         const weight = order.weight ? Math.ceil(order.weight * 1000) : 1000;

    //         const res = await axios.post("/rajaongkir/cost", {
    //             city_id: selectedCity,
    //             courier,
    //             weight,
    //         });

    //         setShippingCost(res.data[0]?.cost[0] || null);
    //     } catch (err) {
    //         alert("Gagal cek ongkir.");
    //     } finally {
    //         setCheckingOngkir(false);
    //     }
    // };



    const fetchBankAccounts = async () => {
        try {
            const res = await axios.get("/bank-accounts");
            setAccounts(res.data[0]);
        } catch (err) {
            console.error("Error fetching bank accounts:", err);
            alert("Gagal memuat data rekening bank.");
        }
    };

    const fetchOrder = async () => {
        try {
            const res = await axios.get(`/orders/${id}`);
            setOrder(res.data);
            setPhotos(Array.isArray(res.data.photos) ? res.data.photos : []);
        } catch (err) {
            console.error("Error fetching order:", err);
            alert("Gagal memuat data pesanan.");
        }
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("proof", file);

        try {
            await axios.post(`/orders/${id}/upload-proof`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // Authorization jika perlu
                }
            });
            setSuccess("Bukti transfer berhasil diunggah. Menunggu verifikasi.");
            fetchOrder(); // Refresh order data
        } catch {
            alert("Gagal upload bukti transfer.");
        }
    };

    const validateResolution = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                if (img.width >= 1000 && img.height >= 1000) {
                    resolve(true);
                } else {
                    reject(`Foto harus minimal 1000x1000px (${img.width}x${img.height})`);
                }
            };
            img.onerror = () => reject("Gagal membaca resolusi gambar.");
            img.src = URL.createObjectURL(file);
        });
    };

    const handleFileChange = async (e) => {
        setUploadError("");
        const files = Array.from(e.target.files);

        // Validasi jumlah maksimal foto sesuai jumlah halaman
        if (order && photos.length + files.length > order.page_number_total) {
            setUploadError(
                `Maksimal ${order.page_number_total} foto sesuai jumlah halaman.`
            );
            return;
        }

        const formData = new FormData();
        // files.forEach((file) => formData.append("photos[]", file));


        try {
            setUploading(true);

            for (const file of files) {
                await validateResolution(file); // ⛔️ throw error jika tidak lolos
                formData.append("photos[]", file);
            }
            const res = await axios.post(`/orders/${id}/upload-photos`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            setPhotos(res.data.photos);
        } catch (err) {
            setUploadError("Gagal upload foto. " + err.message);
        } finally {
            setUploading(false);
        }
    };

    const handleDeletePhoto = async (filename) => {
        try {
            const res = await axios.post(`/orders/${id}/delete-photo`, {
                filename,
            });
            setPhotos(res.data.photos);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSubmitPhotos = async () => {
        setSubmitMessage("");

        if (parseInt(photos.length) !== parseInt(order?.pages)) {
            setError(`Jumlah foto harus ${order?.pages}, sekarang ${photos.length}`);

            return;
        }

        try {
            // const res = await axios.post(`/orders/${id}/submit-photos`, {
            //     photos,
            // });
            setSubmitMessage("✅ Foto berhasil disubmit!");
            fetchOrder()
        } catch (err) {
            // setSubmitMessage("❌ Gagal submit.");
            setError("❌ Gagal submit. " + err.response?.data?.message || "Terjadi kesalahan.");
        }
    };

    if (!order) return <p>Memuat...</p>;

    // const grandTotal = parseInt(order.total_price) + parseInt(order.unique_code);

    return (
        <>
            <div className="card mt-24">
                <ErrorModal error={error} onClose={() => setError("")} />

                <div className="card-header border-bottom">
                    {
                        order.proof_file ? (
                            <div className="position-absolute top-0 end-0 p-5 ">
                                <h3 className="text-success vertical-center">PAID</h3>
                            </div>
                        ) : null
                    }
                    <h4 className="mb-4">{(order?.status === 'verified' || order?.status === 'paid' || order?.status === 'pending') ? 'Checkout' : 'Detail'} Pesanan</h4>
                    <p className="text-gray-600 text-15">Pastikan data pesanan sudah benar, dan lakukan transfer pada informasi rekening yang tersedia</p>
                </div>
                <div className="card-body">
                    <div className="row gy-4">
                        <div className="col-md-6 col-sm-6">
                            <div className="plan-item rounded-16 border border-gray-100 transition-2 position-relative">
                                <h3 className="mb-4">{order?.product?.name}</h3>
                                <span className="text-gray-600">{order?.product?.category?.name} - {order?.product?.sub_category?.name}</span>
                                <h2 className="h1 fw-medium text-main mb-32 mt-16 pb-32 border-bottom border-gray-100 d-flex gap-4">
                                    Rp. {formatCurrency(parseInt(order.price_total) + parseInt(order.unique_code))}
                                </h2>
                                <ul>
                                    <li className="flex-align gap-8 text-gray-600 mb-lg-4 mb-20">
                                        <span className="text-24 d-flex text-main-600"><i className="ph ph-check-circle"></i></span>
                                        Size {order?.size?.name}
                                    </li>
                                    <li className="flex-align gap-8 text-gray-600 mb-lg-4 mb-20">
                                        <span className="text-24 d-flex text-main-600"><i className="ph ph-check-circle"></i></span>
                                        Cover Design {order?.cover_design?.name}
                                    </li>
                                    <li className="flex-align gap-8 text-gray-600 mb-lg-4 mb-20">
                                        <span className="text-24 d-flex text-main-600"><i className="ph ph-check-circle"></i></span>
                                        Cover Fabric {order?.cover_fabric?.name}
                                    </li>
                                    <li className="flex-align gap-8 text-gray-600 mb-lg-4 mb-20">
                                        <span className="text-24 d-flex text-main-600"><i className="ph ph-check-circle"></i></span>
                                        {order?.pages} pages
                                    </li>
                                </ul>

                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6">
                            
                            <div className="plan-item rounded-16 border border-gray-100 transition-2 position-relative">
                                <h3 className="mb-4">Metode Pembayaran</h3>
                                <span className="text-gray-600 mb-5">Manual Transfer</span>
                                <p className="text-gray-600 mb-5">Transfer ke rekening: <strong>{accounts.account_number} ({accounts.bank_name} a/n {accounts.account_name})</strong></p>
                                <p className="text-gray-600 mb-5">Total: <strong>Rp {formatCurrency(parseInt(order.price_total) + parseInt(order.unique_code))}</strong></p>
                                <p className="text-gray-600 mb-5"><small>Harga sudah termasuk kode unik: {order.unique_code}</small></p>

                                {order.proof_file ? (
                                    <>
                                        <div className="alert alert-info">
                                            {
                                                order.status === "pending" ? (
                                                    <span className="text-warning">Bukti transfer belum diverifikasi</span>
                                                ) : order.status === "verified" ? (
                                                    <span className="text-success">Bukti transfer sudah diverifikasi</span>
                                                ) : (
                                                    <span className="text-danger">Bukti transfer ditolak</span>
                                                )
                                            }
                                            <br />
                                            <a href={`${STORAGE_URL}${order.proof_file}`} target="_blank" rel="noopener noreferrer">Lihat Bukti Transfer</a>
                                        </div>
                                    </>
                                ) : (
                                    <form onSubmit={handleUpload} className="mt-3">
                                        <input
                                            type="file"
                                            className="form-control mb-2"
                                            accept="image/*"
                                            onChange={(e) => setFile(e.target.files[0])}
                                            required
                                        />
                                        <button className="btn btn-primary">Upload Bukti Transfer</button>
                                    </form>
                                )}

                                {success && <div className="alert alert-success mt-3">{success}</div>}

                            </div>
                        </div>

                        {
                            (order.status === "verified" || order.status === "submitted" || order.status === "delivery") &&
                            <div className="col-md-12 col-sm-12">
                                <div className="plan-item rounded-16 border border-gray-100 transition-2 position-relative">
                                    <h3 className="mb-4">Upload Foto</h3>
                                    {uploadError && <p className="text-danger">{uploadError}</p>}

                                    {
                                        order.status === "verified" &&
                                        <div className="mb-4">
                                            <label className="form-label">File Foto (Harus HD)</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                multiple
                                                disabled={uploading}
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                    }


                                    {uploading && <p>Uploading...</p>}

                                    <ReactSortable list={photos} setList={setPhotos} disabled={order.status === 'submitted'} className="row mt-4">
                                        {photos.map((photoUrl, index) => (
                                            <div className="col-4 col-sm-3 col-md-2 mb-3" key={index}>
                                                <div className="position-relative">
                                                    <img
                                                        src={`${STORAGE_URL}${photoUrl}`}
                                                        className="img-fluid rounded border"
                                                        alt={`photo-${index}`}
                                                    />
                                                    {
                                                        order.status === "verified" &&
                                                        <button onClick={() => handleDeletePhoto(photoUrl)} type="button" class="follow-btn py-2 px-8 flex-align gap-4 text-13 fw-medium text-danger border border-danger rounded-pill position-absolute inset-block-start-0 inset-inline-end-0 mt-8 me-8 transition-1">
                                                            <i class="ph ph-trash d-flex"></i>
                                                        </button>
                                                    }

                                                </div>
                                            </div>
                                        ))}
                                    </ReactSortable>

                                    {
                                        order.status === "verified" &&
                                        <button
                                            className="btn btn-primary mt-3"
                                            onClick={() => handleSubmitPhotos()}
                                        >
                                            Submit Foto
                                        </button>
                                    }

                                </div>
                            </div>
                        }


                    </div>
                </div>
            </div>
        </>
    );
}
